module.exports = __webpack_public_path__ + "fonts/fa-solid-900.205f07b3.ttf";